import { Spin } from 'antd';
import GameEmbedInfo from 'components/Embeds/GameEmbedInfo';
import DashboardTile from './DashboardTile';

const DashboardGame = ({ game, loading, title, clickable = false }) => {
  const handleGameClick = () => {
    if (game?.gameId) {
      window.open(`/embed/game?gameId=${game.gameId}`, '_blank');
    }
  };

  return (
    <DashboardTile title={title} className="w-full max-w-[700px]">
      {loading ? (
        <div className="text-gray-400 text-center py-4"><Spin /></div>
      ) : game ? (
        <div 
          onClick={clickable ? handleGameClick : undefined}
          className={clickable ? "cursor-pointer hover:opacity-90 transition-opacity" : ""}
        >
          <GameEmbedInfo data={game} lang='en' noBorder={true} />
        </div>
      ) : (
        <div className="text-gray-400 text-center py-4">No {title.toLowerCase()}</div>
      )}
    </DashboardTile>
  )
}

export default DashboardGame
